import Vue from 'vue'
import Wsefy from 'wsefy/src'
Vue.use(Wsefy)
